/* Utils */
export function isVegaOS() {
  return navigator.userAgent.includes('Kepler') || navigator.userAgent.includes('AFT');
}

export function closeApp() {
  if (isVegaOS()) {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: 'action-close-app' }),
    );
  }
  navigator.app.exitApp();
}

function getModelFireTV(nameModelUserAgent) {
  switch (nameModelUserAgent) {
    case 'AFTKA': {
      return 'Fire TV Stick 4K Max - 1st Gen (2021)';
    }
    case 'AFTTIFF43': {
      return 'Fire TV Omni Series (2021)';
    }
    case 'AFTTI43': {
      return 'FFire TV 4-Series (2021)';
    }
    case 'AFTWI001': {
      return 'ok 4K - Fire TV (2020)';
    }
    case 'AFTSSS': {
      return 'Fire TV Stick - 3rd Gen (2020)';
    }
    case 'AFTSS': {
      return 'Fire TV Stick Lite - 1st Gen (2020)';
    }
    case 'AFTT': {
      return 'Fire TV Stick - 2nd Gen (2016-2019)';
    }
    case 'AFTR': {
      return 'Fire TV Cube - 2nd Gen (2019)';
    }
    case 'AFTA': {
      return 'Fire TV Cube - 1st Gen (2018)';
    }
    case 'AFTMM': {
      return 'Fire TV Stick 4K - 1st Gen (2018)';
    }
    case 'AFTRS': {
      return 'Element 4K - Fire TV (2017)';
    }
    case 'AFTN': {
      return 'Fire TV - 3rd Gen (2017)';
    }
    case 'AFTS': {
      return 'Fire TV - 2nd Gen (2015)';
    }
    case 'AFTM': {
      return 'Fire TV Stick - 1st Gen (2014)';
    }
    case 'AFTB': {
      return 'Fire TV - 1st Gen (2014)';
    }
    default: {
      return nameModelUserAgent;
    }
  }
}
export function changeBackButtonActions() {
  window.addEventListener('load', () => {
    document.addEventListener('backbutton', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.dispatchEvent(new Event('customback'));
    }, false);
  });
}

export async function getDeviceInfo() {
  const [, buildVersion] = /build\/(\S[^)]+)/i.exec(navigator.userAgent) || [];
  const [modelAFTName] = /aft+\S+/i.exec(navigator.userAgent);
  const [isVega] = /kepler/i.exec(navigator.userAgent);
  const [, vegaOSVersion] = /kepler ([^;])/i.exec(navigator.userAgent);

  return {
    os: isVega || '', // Kepler
    sdkVersion: vegaOSVersion, // Kepler 1.1
    buildVersion,
    screenWidth: window?.screen?.width || '',
    screenHeight: window?.screen?.height || '',
    modelName: modelAFTName ? getModelFireTV(modelAFTName) : '',
    modelAFTName,
  };
}
